export default __webpack_public_path__ + "static/img_case_03-a60b631394e7f82648dd2b7222072490.webp";